import { FC, ReactNode } from "react"
import { Dayjs } from "dayjs"
import Button from "@/components/shared/Button"
import DatePicker from "@/components/shared/DatePicker"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"
import { useExportDateRange } from "@/hooks/useExportDateRange"
import "./index.scss"

const DATE_FORMAT = "YYYY-MM-DD"
const HALF_WIDTH = { xs: 12, sm: 6, md: 6, lg: 6 }

export interface ExportRange {
   startDate: Dayjs
   endDate: Dayjs
}

interface ExportRowProps {
   title: string
   description: string
   timezone: string
   loading: boolean
   onRequest: (range: ExportRange) => void
   extraControls?: ReactNode
}

const ExportRow: FC<ExportRowProps> = ({
   title,
   description,
   timezone,
   loading,
   onRequest,
   extraControls,
}) => {
   const { startDate, endDate, changeStartDate, changeEndDate } =
      useExportDateRange()

   return (
      <section
         className="export-row"
         aria-label={title}
      >
         <Grid>
            <GridItem size={HALF_WIDTH}>
               <div className="export-row__content">
                  <div className="export-row__title">{title}</div>
                  <div className="export-row__description">{description}</div>
               </div>
            </GridItem>
            <GridItem size={HALF_WIDTH}>
               <div className="export-row__controls">
                  {extraControls && (
                     <div className="export-row__extra">{extraControls}</div>
                  )}
                  <div className="export-row__date-field">
                     <DatePicker
                        label="Start date"
                        selectedDate={startDate}
                        timezone={timezone}
                        onDateChange={changeStartDate}
                        maxDate={endDate}
                        size="small"
                        format={DATE_FORMAT}
                     />
                  </div>
                  <div className="export-row__date-field">
                     <DatePicker
                        label="End date"
                        selectedDate={endDate}
                        timezone={timezone}
                        onDateChange={changeEndDate}
                        minDate={startDate}
                        size="small"
                        format={DATE_FORMAT}
                     />
                  </div>
                  <Button
                     className="export-row__request-button"
                     onClick={() => onRequest({ startDate, endDate })}
                     disabled={loading}
                  >
                     {loading ? "Requesting…" : "Request"}
                  </Button>
               </div>
            </GridItem>
         </Grid>
      </section>
   )
}

export default ExportRow
